import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { ref, reactive, onMounted, toRefs } from 'vue';
import apis from "@/api";
export default {
  name: "UserRoles",
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const roleTreeProps = {
      children: 'children',
      label: 'roleName'
    };
    const roleTreeRef = ref(null);
    const data = reactive({
      roleTrees: [],
      userInfo: {}
    });
    const initUserRoles = userInfo => {
      data.userInfo = userInfo;
      apis.rolesByUserId({
        userId: userInfo.userId
      }).then(res => {
        if (res.success) {
          const checkedKeys = res.data.map(r => {
            return r.roleId;
          });
          roleTreeRef.value.setCheckedKeys(checkedKeys, false);
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const hanldeSubmit = () => {
      const checkedKeys = [];
      const nodes = roleTreeRef.value.getCheckedNodes();
      for (let node of nodes) {
        if (node.children.length == 0) {
          checkedKeys.push(node.roleId);
        }
      }
      apis.saveUserRoles({
        userId: data.userInfo.userId,
        roleIds: checkedKeys.join(',')
      }).then(res => {
        if (res.success) {
          ElMessage.success('用户角色保存成功');
          close();
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    const close = () => {
      context.emit('update:visible', false);
    };
    const initAllRoles = () => {
      apis.roleTree().then(res => {
        if (res.success) {
          data.roleTrees = res.data;
        } else {
          ElMessage.error(res.msg);
        }
      });
    };
    onMounted(() => {
      initAllRoles();
    });
    return {
      ...toRefs(data),
      roleTreeRef,
      close,
      roleTreeProps,
      initUserRoles,
      hanldeSubmit
    };
  }
};